export default function BusinessContent() {
  return (
    <section id="business" className="w-full bg-stone-50">
      {/* Section Header */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12 text-center">
        <p className="text-amber-600 text-xs tracking-[0.5em] uppercase mb-3">Our Business</p>
        <h2 className="text-stone-900 text-3xl lg:text-4xl font-light mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          事業内容
        </h2>
        <div className="w-12 h-px bg-amber-500 mx-auto" />
      </div>

      {/* Main Content: Photo + Text Vertical Layout */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pb-20">
        {/* Large Feature Photo */}
        <div className="w-full h-[480px] lg:h-[580px] overflow-hidden rounded-lg mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/8bbb47792c3d7e2828bf0f9ec99941e5.jpg"
            alt="貸別荘の運営"
            className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
          />
        </div>

        {/* Text Content Below Photo */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <h3 className="text-stone-900 text-2xl lg:text-3xl font-light mb-6 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              贅沢な<strong className="font-semibold">貸別荘</strong>の運営を<br />
              あなたの代わりに、丁寧に。
            </h3>
            <p className="text-stone-600 text-base leading-relaxed mb-4">
              私たちは貸別荘・民泊の企画立案から、各種申請手続きの代行、
              日々の管理業務、そして物件のリフォームまで、
              オーナー様が必要とするすべてのサービスをワンストップで提供します。
            </p>
            <p className="text-stone-600 text-base leading-relaxed">
              豊富な実績と専門知識を活かし、魅力的な滞在体験を生み出す
              貸別荘・民泊物件の価値を最大化するお手伝いをいたします。
            </p>
          </div>
          <div className="flex flex-col gap-6">
            {[
              { icon: 'ri-home-heart-line', title: '貸別荘の運営', desc: '企画から日常管理まで、物件の魅力を最大限に引き出すトータルサポート' },
              { icon: 'ri-file-text-line', title: '各種申請代行', desc: '民泊・簡易宿所の複雑な申請手続きを専門スタッフが代行いたします' },
              { icon: 'ri-tools-line', title: '建物リフォーム', desc: '集客力を高めるリノベーションで物件の価値と稼働率を向上させます' },
            ].map((item) => (
              <div key={item.title} className="flex gap-4 items-start p-5 bg-white rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center text-amber-600 flex-shrink-0">
                  <i className={`${item.icon} text-2xl`} />
                </div>
                <div>
                  <h4 className="text-stone-800 font-medium mb-1">{item.title}</h4>
                  <p className="text-stone-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
